import { useState } from 'react'
import { useGetIdentity } from 'react-admin'
import { Stack, Box, Tab, Tabs, Typography, useMediaQuery } from '@mui/material'

import PaieSettings from './PaieSettings'
import DashboardBase from './DashboardBase'
import { getRole } from '../../common/roles'
import DashboardHippocast from '../hippocast'
import DashboardRespoPaies from './DashboardRespoPaies'

const CustomTabPanel = ({ children, value, index, ...other }) => (
  <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
    {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
  </div>
)

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

const RespoDashboardConfig = () => {
  const isMobile = useMediaQuery(
    theme => theme.breakpoints.down('md'),
    { noSsr: true }
  )
  const { data: identity } = useGetIdentity()
  const isAdmin = identity?.role?.grade === getRole('admin')

  const [value, setValue] = useState(0)

  return (
    <Box sx={{ mt: isMobile ? 1 : 4, px: isMobile ? 1 : 3, fontSize: '1rem' }}>
      {isMobile ? (
        <>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            Mon tableau de bord
          </Typography>

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={(event, newValue) => setValue(newValue)}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Vue générale" {...a11yProps(0)} />
              <Tab label="Paies pubeurs" {...a11yProps(1)} />
              <Tab label="Réglages paies" {...a11yProps(2)} />
              {isAdmin && <Tab label="Hippocast" {...a11yProps(3)} />}
            </Tabs>
          </Box>
        </>
      ) : (
        <Stack spacing={2} direction="row" flex="1" alignItems="center" justifyContent="space-between" sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Mon tableau de bord</Typography>

          <Box>
            <Tabs value={value} onChange={(event, newValue) => setValue(newValue)}>
              <Tab label="Vue générale" {...a11yProps(0)} />
              <Tab label="Paies pubeurs" {...a11yProps(1)} />
              <Tab label="Réglages paies" {...a11yProps(2)} />
              {isAdmin && <Tab label="Hippocast" {...a11yProps(3)} />}
            </Tabs>
          </Box>
        </Stack>
      )}

      <CustomTabPanel value={value} index={0}><DashboardBase /></CustomTabPanel>
      <CustomTabPanel value={value} index={1}><DashboardRespoPaies /></CustomTabPanel>
      <CustomTabPanel value={value} index={2}><PaieSettings isAdmin={isAdmin} identity={identity} /></CustomTabPanel>
      <CustomTabPanel value={value} index={3}><DashboardHippocast /></CustomTabPanel>
    </Box>
  )
}

export default RespoDashboardConfig